import styled from 'styled-components';

export type SectionProps = {
  gutterTop?: number;
  gutterBottom?: number;
};

const Section = styled.section<SectionProps>((props) => ({
  ...(props.gutterTop && { marginTop: props.theme.spacing(props.gutterTop) }),
  ...(props.gutterBottom && {
    marginBottom: props.theme.spacing(props.gutterBottom),
  }),
}));

export default Section;
